// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__yHFYw","container":"Gallery_container__Hb85d","heading":"Gallery_heading__rdayS","events":"Gallery_events__Uuba+","noteCard":"Gallery_noteCard__FPTtU"};